import { useState } from 'react';
import type { SearchFilters } from '../types';

interface SearchFiltersProps {
  onSearch: (filters: SearchFilters) => void;
}

export default function SearchFiltersComponent({ onSearch }: SearchFiltersProps) {
  const [searchType, setSearchType] = useState<SearchFilters['searchType']>('tenantName');
  const [searchValue, setSearchValue] = useState('');
  const [startMonth, setStartMonth] = useState('');
  const [endMonth, setEndMonth] = useState('');
  const [status, setStatus] = useState('');

  const handleSearch = () => {
    onSearch({
      searchType,
      searchValue,
      startMonth,
      endMonth,
      status,
    });
  };

  const handleReset = () => {
    setSearchType('tenantName');
    setSearchValue('');
    setStartMonth('');
    setEndMonth('');
    setStatus('');
    onSearch({
      searchType: 'tenantName',
      searchValue: '',
      startMonth: '',
      endMonth: '',
      status: '',
    });
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mb-4">
      <div className="grid grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">搜索类型</label>
          <select
            value={searchType}
            onChange={(e) => setSearchType(e.target.value as SearchFilters['searchType'])}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 cursor-pointer"
          >
            <option value="tenantId">租户ID</option>
            <option value="tenantName">租户名称</option>
            <option value="userId">用户ID</option>
            <option value="userName">用户名称</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">搜索内容</label>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="请输入搜索内容"
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">开始月份</label>
          <input
            type="month"
            value={startMonth}
            onChange={(e) => setStartMonth(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">结束月份</label>
          <input
            type="month"
            value={endMonth}
            onChange={(e) => setEndMonth(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">账单状态</label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 cursor-pointer"
          >
            <option value="">全部</option>
            <option value="出账中">出账中</option>
            <option value="已出账">已出账</option>
          </select>
        </div>
      </div>

      <div className="flex gap-2">
        <button
          onClick={handleSearch}
          className="px-4 py-2 bg-teal-600 text-white text-sm rounded-md hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-search-line mr-1"></i>
          搜索
        </button>
        <button
          onClick={handleReset}
          className="px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-md hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line mr-1"></i>
          重置
        </button>
      </div>
    </div>
  );
}
